module.exports = __webpack_public_path__ + "static/doula2-3fd0328262d7ec993577b61bbde32870.jpg";